import { CustomerPaymentPayComponent } from "Components/Customer/Payment/CustomerPaymentPayComponent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useSearchParams } from "Navigation/useSearchParams";
import { Navigate } from "Navigation/Navigate";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";
import { useParams } from "react-router-dom";

const PageResources = Resources.Customer.Pay;

export const CustomerPaymentPayPage = () => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();
  const { id } = useParams<{ id: string }>();

  const publicID = searchParams.get("publicID");

  if (!id) {
    const query = publicID ? `?publicID=${encodeURIComponent(publicID)}` : "";
    return <Navigate to={`${appUrl("send-payment")}${query}`} replace />;
  }

  return (
    <AuthenticatedLayout
      title={t(PageResources.Title)}
      backNavigation={{
        mode: "staticUrl", // can't use history stack, because prev page might be NFC/Paypoint redirect, which would directly send me back here
        url: appUrl("dashboard"),
      }}
      isBottomMenuHidden
    >
      <StyledPageWrapper>
        <CustomerPaymentPayComponent
          publicID={publicID}
          transactionPublicID={id}
        />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default CustomerPaymentPayPage;
